import { LsCountdown, LsCountdownOptions } from 'ls-countdown';
import {CountUp} from 'countup.js';
import _merge from 'lodash-es/merge';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import zeroFill from 'zero-fill';

dayjs.extend(customParseFormat);

import { $, $$ } from './utils/querySelector';

const DEFAULT_OPTIONS = {
    selector: '[data-ghwp-countdown]',
    debug: false,
};

export class CountdownFactory {
    constructor(userOptions) {
        this.options = {};
        this.elements = [];
        this.countdowns = [];

        this.parseOptions(userOptions);
        this.findElements();
        this.initCountdowns();
    }

    findElements() {
        this.elements = $$()(this.options.selector);
    }

    initCountdowns() {
        this.elements.forEach((element) => {
            try {
                this.countdowns.push(new Countdown(element, this.options));
            } catch (e) {
                console.warn('ghwp-countdown: Failed to initialize.');
            }
        });
    }

    parseOptions(userOptions) {
        this.options = _merge(DEFAULT_OPTIONS, userOptions);
    }
}

export class Countdown {
    constructor(root, userOptions = {}) {
        this.options = {};
        this.targetTime = null;
        this.countdown = null;
        this.countUps = {};
        this.countUpFinished = false;
        this.previousMinute = 0;

        this.onUpdate = this.onUpdate.bind(this);
        this.onStart = this.onStart.bind(this);

        this.root = root;

        this.parseOptions(userOptions);
        this.findElements();
        this.init();
    }

    findElements() {
        this.elements = {
            days: $(this.root)('[data-ghwp-counter-days]'),
            hours: $(this.root)('[data-ghwp-counter-hours]'),
            minutes: $(this.root)('[data-ghwp-counter-minutes]'),
            seconds: $(this.root)('[data-ghwp-counter-seconds]'),
        };
    }

    init() {
        this.targetTime = dayjs(this.root.dataset.ghwpCountdown, 'DD.MM.YYYY');
        if (this.targetTime.isBefore(dayjs())) {
            this.root.classList.add('hidden');
        }
        const cdOptions = new LsCountdownOptions({
            targetDate: this.targetTime.toDate(),
            onStart: this.onStart,
            onTick: this.onUpdate,
            sufixes: {
                days: '',
                hours: '',
                minutes: '',
                seconds: '',
            },
        });
        this.countdown = new LsCountdown(cdOptions);
        this.countdown.start();
    }

    onStart(timespan) {
        this.previousMinute = timespan.minutes;

        Object.keys(this.elements).forEach(key => {
            const element = this.elements[key];
            const options = {
                startVal: element.innerText,
                useGrouping: false,
            };
            options.formattingFn = (n) => zeroFill(2, n);
            this.countUps[key] = new CountUp(element, timespan[key], options);
        });

        Object.keys(this.countUps).forEach((key) => {
            const countup = this.countUps[key];
            countup.start(() => {
                countup.pauseResume();
                delete this.countUps[key];
                if (!Object.keys(this.countUps).length) {
                    this.countUpFinished = true;
                }
            });
        })
    }

    onUpdate(timespan) {
        if (this.countUpFinished) {
            Object.keys(this.elements).forEach((key) => {
                this.elements[key].innerText = timespan[key];
            });
        } else {
            this.previousMinute = timespan.minutes;

            const secondCU = this.countUps['seconds'];

            if (secondCU) {
                secondCU.options.duration = .5;
                secondCU.update(timespan.seconds);
            } else {
                this.elements.seconds.innerText = timespan.seconds;
            }

            if (this.previousMinute !== timespan.minutes) {
                const minuteCU = this.countUps['minutes'];
                if (minuteCU) {
                    minuteCU.options.duration = .5;
                    minuteCU.update(timespan.minutes);
                } else {
                    this.elements.minutes.innerText = timespan.minutes;
                }
            }

        }
    }

    parseOptions(userOptions) {
        this.options = _merge(DEFAULT_OPTIONS, userOptions);
    }
}
